(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aromadd-blog-article"] && !Shopify.designMode) return;
  try {
    
  function buildAromaddBlogToc(scope) {
    var articles = scope.querySelectorAll('.aromadd-blog-article');

    articles.forEach(function(article) {
      var content = article.querySelector('.aromadd-blog-article__content');
      var toc = article.querySelector('.aromadd-blog-article__toc');
      var tocBlocks = article.querySelectorAll('.aromadd-blog-article__toc, .aromadd-blog-article__mobile-toc');
      var lists = article.querySelectorAll('.aromadd-blog-article__toc-list');
      var sidebar = article.querySelector('.aromadd-blog-article__sidebar');

      if (!content || lists.length === 0) {
        return;
      }

      var headings = Array.prototype.slice.call(content.querySelectorAll('h2')).filter(function(heading) {
        return heading.textContent.trim().length > 0;
      });

      lists.forEach(function(list) {
        list.innerHTML = '';
      });

      if (headings.length === 0) {
        tocBlocks.forEach(function(tocBlock) {
          tocBlock.hidden = true;
        });
        if (sidebar && !sidebar.querySelector('.aromadd-blog-article__cta')) {
          sidebar.hidden = true;
        }
        return;
      }

      tocBlocks.forEach(function(tocBlock) {
        tocBlock.hidden = false;
      });
      if (sidebar) {
        sidebar.hidden = false;
      }

      var usedIds = {};

      headings.forEach(function(heading, index) {
        var text = heading.textContent.trim();
        var id = heading.id;

        if (!id) {
          id = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        }

        if (!id) {
          id = 'section-' + (index + 1);
        }

        var uniqueId = id;
        var counter = 2;

        while (usedIds[uniqueId] || document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading) {
          uniqueId = id + '-' + counter;
          counter += 1;
        }

        usedIds[uniqueId] = true;
        heading.id = uniqueId;

        var item = document.createElement('li');
        var link = document.createElement('a');

        link.href = '#' + uniqueId;
        link.textContent = text;
        item.appendChild(link);

        lists.forEach(function(list) {
          list.appendChild(item.cloneNode(true));
        });
      });

      article.querySelectorAll('.aromadd-blog-article__mobile-toc a').forEach(function(link) {
        link.addEventListener('click', function() {
          var details = link.closest('.aromadd-blog-article__mobile-toc');
          if (details) {
            details.open = false;
          }
        });
      });
    });
  }

  buildAromaddBlogToc(document);

  document.addEventListener('shopify:section:load', function(event) {
    buildAromaddBlogToc(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aromadd-blog-index"]) return;
  try {
    
  class AromaddBlogIndex extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-aromadd-blog-item]'));
      this.searchInput = this.querySelector('[data-aromadd-blog-search]');
      this.emptyState = this.querySelector('[data-aromadd-blog-empty]');
      this.loadButton = this.querySelector('[data-aromadd-blog-load-more]');
      this.loadMoreWrapper = this.loadButton ? this.loadButton.closest('.aromadd-blog-index__load-more') : null;
      this.initialCount = Number(this.dataset.initialCount) || 9;
      this.loadCount = Number(this.dataset.loadCount) || 6;
      this.visibleCount = this.initialCount;
      this.filteredItems = this.items;

      if (this.loadButton) {
        this.loadButton.addEventListener('click', () => this.loadMore());
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', () => this.filterItems());
      }

      this.render();
    }

    filterItems() {
      const query = this.searchInput.value.trim().toLowerCase();
      this.visibleCount = this.initialCount;

      this.filteredItems = this.items.filter((item) => {
        if (!query) {
          return true;
        }

        return item.textContent.toLowerCase().includes(query);
      });

      this.render();
    }

    loadMore() {
      if (this.filteredItems.length <= this.visibleCount) {
        return;
      }

      this.visibleCount += this.loadCount;
      this.render();
    }

    render() {
      const visibleItems = this.filteredItems.slice(0, this.visibleCount);

      this.items.forEach((item) => {
        item.hidden = !visibleItems.includes(item);
      });

      if (this.emptyState) {
        this.emptyState.hidden = this.filteredItems.length > 0;
      }

      if (this.loadMoreWrapper) {
        this.loadMoreWrapper.hidden = this.filteredItems.length <= this.visibleCount;
      }
    }
  }

  if (!customElements.get('aromadd-blog-index')) {
    customElements.define('aromadd-blog-index', AromaddBlogIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-bundle-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bts-bundle-form')) {
    customElements.define('bts-bundle-form', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-bts-bundle-add]');
        this.error = this.querySelector('[role="alert"]');
        this.total = this.querySelector('[data-bts-bundle-total]');
        this.qualifies = this.querySelector('[data-bts-bundle-qualifies]');
        this.variantSelectors = [...this.querySelectorAll('[data-bts-bundle-variant]')];
        this.variantSelectors.forEach((selector) => selector.addEventListener('change', () => this.updateState()));
        this.button?.addEventListener('click', () => this.addBundle());
        this.updateState();
      }

      selectedVariant(position) {
        const selector = this.querySelector(`[data-bts-bundle-variant="${position}"]`);
        if (selector) {
          const option = selector.options[selector.selectedIndex];
          return { id: Number(option.value), price: Number(option.dataset.price), available: option.dataset.available === 'true' };
        }

        return {
          id: Number(this.button.dataset[`${position}Variant`]),
          price: Number(this.button.dataset[`${position}Price`]),
          available: this.button.dataset[`${position}Available`] === 'true'
        };
      }

      updateState() {
        if (!this.button) return;
        const first = this.selectedVariant('first');
        const second = this.selectedVariant('second');
        const third = this.selectedVariant('third');
        const selectedVariants = [first, second, third].filter((variant) => variant.id);
        const total = selectedVariants.reduce((sum, variant) => sum + variant.price, 0);
        const available = selectedVariants.length >= 2 && selectedVariants.every((variant) => variant.available);

        this.button.disabled = !available;
        this.button.textContent = available ? this.button.dataset.availableLabel : this.button.dataset.unavailableLabel;
        if (this.total && Number.isFinite(total)) {
          this.total.textContent = window.Shopify?.formatMoney ? Shopify.formatMoney(total, this.dataset.moneyFormat) : `$${(total / 100).toFixed(2)}`;
        }
        if (this.qualifies) this.qualifies.hidden = total < Number(this.qualifies.dataset.threshold);
      }

      async addBundle() {
        const selectedVariants = ['first', 'second', 'third']
          .map((position) => this.selectedVariant(position))
          .filter((variant) => variant.id);
        if (selectedVariants.length < 2) return;
        this.button.setAttribute('aria-busy', 'true');
        this.error.hidden = true;
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: selectedVariants.map((variant) => ({ id: variant.id, quantity: 1 })),
              sections,
              sections_url: this.button.dataset.sectionUrl
            })
          });
          const responseJson = await response.json();
          if (!response.ok) throw new Error(responseJson.description || responseJson.message);
          const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cart.sections = responseJson.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart }
          }));
        } catch (error) {
          this.error.textContent = error.message;
          this.error.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } finally {
          this.button.removeAttribute('aria-busy');
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-gift-threshold"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bts-gift-progress')) {
    customElements.define('bts-gift-progress', class extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.getAttribute('threshold')) || 16000;
        this.message = this.querySelector('[data-bts-progress-message]');
        this.bar = this.querySelector('[data-bts-progress-bar]');
        this.track = this.querySelector('[role="progressbar"]');
        this.onCartChange = (event) => event.detail?.cart ? this.update(event.detail.cart) : this.refresh();
        document.addEventListener('cart:change', this.onCartChange);
        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:change', this.onCartChange);
      }

      async refresh() {
        try {
          const response = await fetch(`${Shopify.routes.root}cart.js`);
          if (response.ok) this.update(await response.json());
        } catch (error) {
          this.dataset.status = 'unavailable';
        }
      }

      update(cart) {
        const subtotal = Number(cart.total_price) || 0;
        const remaining = Math.max(0, this.threshold - subtotal);
        const percentage = Math.min(100, subtotal / this.threshold * 100);
        const formatter = new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: Shopify.currency.active });
        this.bar.style.width = `${percentage}%`;
        this.track.setAttribute('aria-valuenow', String(subtotal));
        this.message.textContent = remaining === 0
          ? this.getAttribute('unlocked-message')
          : this.getAttribute('away-template').replace('[amount]', formatter.format(remaining / 100));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bts-scent-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bts-scent-selector')) {
    customElements.define('bts-scent-selector', class extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.getAttribute('threshold')) || 16000;
        this.selectedVariantId = null;
        this.cart = null;
        this.addButton = this.querySelector('[data-bts-scent-add]');
        this.status = this.querySelector('[data-bts-gift-status]');
        this.error = this.querySelector('[role="alert"]');
        this.onCartChange = (event) => event.detail?.cart ? this.updateCart(event.detail.cart) : this.refreshCart();
        document.addEventListener('cart:change', this.onCartChange);
        this.addButton?.addEventListener('click', () => this.addSelectedGift());
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-scent-name]');
          if (!button) return;
          this.querySelectorAll('[data-scent-name]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelector('[data-selected-scent]').textContent = button.dataset.scentName;
          this.selectedVariantId = Number(button.dataset.variantId);
          this.selectedVariantAvailable = button.dataset.variantAvailable === 'true';
          this.updateAction();
        });
        this.refreshCart();
      }

      disconnectedCallback() {
        document.removeEventListener('cart:change', this.onCartChange);
      }

      async refreshCart() {
        try {
          const response = await fetch(`${Shopify.routes.root}cart.js`);
          if (!response.ok) throw new Error('Unable to read cart');
          this.updateCart(await response.json());
        } catch (error) {
          if (this.status) this.status.textContent = 'Cart status is temporarily unavailable.';
          this.dataset.status = 'unavailable';
        }
      }

      qualifyingSubtotal(cart) {
        if (!Array.isArray(cart.items)) return Number(cart.total_price) || 0;
        return cart.items.reduce((subtotal, item) => {
          if (String(item.properties?._bts_gift) === 'true') return subtotal;
          return subtotal + (Number(item.final_line_price) || 0);
        }, 0);
      }

      formatMoney(cents) {
        if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, this.getAttribute('money-format'));
        return new Intl.NumberFormat(Shopify.locale || 'en-US', {
          style: 'currency',
          currency: Shopify.currency?.active || 'USD'
        }).format(cents / 100);
      }

      updateCart(cart) {
        this.cart = cart;
        this.subtotal = this.qualifyingSubtotal(cart);
        const remaining = Math.max(0, this.threshold - this.subtotal);
        if (this.status) {
          this.status.textContent = remaining === 0
            ? this.getAttribute('unlocked-message')
            : this.getAttribute('away-template').replace('[amount]', this.formatMoney(remaining));
        }
        this.updateAction();
      }

      updateAction() {
        if (!this.addButton) return;
        const selected = Boolean(this.selectedVariantId && this.selectedVariantAvailable);
        const qualified = Number(this.subtotal) >= this.threshold;
        const campaignGifts = this.campaignGifts();
        const alreadyAdded = campaignGifts.some((item) => Number(item.variant_id || item.id) === this.selectedVariantId);
        const replacing = campaignGifts.length > 0 && !alreadyAdded;
        this.addButton.disabled = !selected || !qualified || alreadyAdded;
        this.addButton.textContent = !selected
          ? this.addButton.dataset.selectLabel
          : !qualified
            ? this.addButton.dataset.lockedLabel
            : alreadyAdded
              ? this.addButton.dataset.alreadyAddedLabel
              : replacing
                ? this.addButton.dataset.replaceLabel
                : this.addButton.dataset.readyLabel;
      }

      campaignGifts() {
        if (!Array.isArray(this.cart?.items)) return [];
        return this.cart.items.filter((item) => String(item.properties?._bts_gift) === 'true');
      }

      async addSelectedGift() {
        if (!this.addButton || this.addButton.disabled || !this.selectedVariantId) return;
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.addButton.textContent = this.addButton.dataset.addingLabel;
        if (this.error) this.error.hidden = true;
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections }
        }));

        try {
          const campaignGifts = this.campaignGifts();
          if (campaignGifts.length > 0) {
            const updates = Object.fromEntries(campaignGifts.map((item) => [item.key, 0]));
            const updateResponse = await fetch(`${Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ updates })
            });
            const updateJson = await updateResponse.json();
            if (!updateResponse.ok) throw new Error(updateJson.description || updateJson.message || 'Unable to replace gift');
          }

          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              items: [{
                id: this.selectedVariantId,
                quantity: 1,
                properties: { _bts_gift: 'true', _bts_campaign: 'back-to-school-2026' }
              }],
              sections,
              sections_url: this.addButton.dataset.sectionUrl
            })
          });
          const responseJson = await response.json();
          if (!response.ok) throw new Error(responseJson.description || responseJson.message || 'Unable to add gift');
          const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
          const cart = await cartResponse.json();
          cart.sections = responseJson.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart }
          }));
          this.updateCart(cart);
        } catch (error) {
          if (this.error) {
            this.error.textContent = error.message;
            this.error.hidden = false;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.updateAction();
        } finally {
          this.addButton.removeAttribute('aria-busy');
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-bundles"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('flash-sale-cart-form')) {

  customElements.define(
    'flash-sale-cart-form',

    class extends HTMLElement {

      connectedCallback() {

        this.form =
          this.querySelector(
            '[data-flash-sale-product-form]'
          );

        this.button =
          this.querySelector(
            '[data-flash-sale-add]'
          );

        this.variantInput =
          this.querySelector(
            '[data-flash-sale-variant-input]'
          );

        this.optionGroups =
          [
            ...this.querySelectorAll(
              '[data-flash-sale-option-group]'
            )
          ];

        this.optionInputs =
          [
            ...this.querySelectorAll(
              '[data-flash-sale-option]'
            )
          ];

        this.legacyInputs =
          [
            ...this.querySelectorAll(
              '[data-flash-sale-legacy-variant]'
            )
          ];

        this.variantData =
          this.parseVariantData();

        this.card =
          this.closest(
            '.flash-sale-bundle-card'
          );

        this.variantImage =
          this.card?.querySelector(
            '[data-flash-sale-variant-image]'
          );

        this.price =
          this.card?.querySelector(
            '[data-flash-sale-price]'
          );

        this.comparePrice =
          this.card?.querySelector(
            '[data-flash-sale-compare-price]'
          );

        this.saving =
          this.card?.querySelector(
            '[data-flash-sale-saving]'
          );

        this.productLinks =
          [
            ...this.card?.querySelectorAll(
              '[data-flash-sale-product-link]'
            ) || []
          ];

        this.error =
          this.querySelector(
            '[role="alert"]'
          );


        this.optionInputs.forEach(
          (input) =>
            input.addEventListener(
              'change',
              () => this.updateVariant()
            )
        );


        this.legacyInputs.forEach(
          (input) =>
            input.addEventListener(
              'change',
              () => this.updateVariant()
            )
        );


        if (this.form) {

          this.form.addEventListener(
            'submit',
            (event) => {

              event.preventDefault();

              this.addToCart();

            }
          );

        } else {

          this.button?.addEventListener(
            'click',
            () => this.addToCart()
          );

        }


        this.updateVariant();

      }


      parseVariantData() {

        const source =
          this.querySelector(
            '[data-flash-sale-variants]'
          );


        if (!source) return [];


        try {

          return JSON.parse(
            source.textContent
          );

        } catch (error) {

          return [];

        }

      }


      updateVariant() {

        if (!this.button) return;


        let variant = null;


        if (
          this.variantData.length &&
          this.optionGroups.length
        ) {

          const selectedOptions =
            this.optionGroups.map(
              (group) =>
                group.querySelector(
                  '[data-flash-sale-option]:checked'
                )?.value
            );


          if (
            selectedOptions.every(Boolean)
          ) {

            variant =
              this.variantData.find(
                (candidate) =>
                  candidate.options.every(
                    (value, index) =>
                      value === selectedOptions[index]
                  )
              );

          }

        } else if (
          this.legacyInputs.length
        ) {

          const selectedLegacyVariant =
            this.legacyInputs.find(
              (input) => input.checked
            );


          if (
            selectedLegacyVariant?.value
          ) {

            variant = {
              id:
                selectedLegacyVariant.value,

              available: true
            };

          }

        } else if (
          this.variantInput?.value
        ) {

          variant = {
            id:
              this.variantInput.value,

            available: true
          };

        } else if (
          this.button?.dataset.variantId
        ) {

          variant = {
            id:
              this.button.dataset.variantId,

            available:
              this.button.dataset.available !==
              'false'
          };

        }


        const variantId =
          variant?.id
            ? String(variant.id)
            : '';


        const available =
          Boolean(
            variant?.available
          );


        this.button.dataset.variantId =
          variantId;


        this.button.dataset.available =
          String(available);


        if (this.variantInput) {
          this.variantInput.value =
            variantId;
        }


        this.button.disabled =
          !variantId ||
          !available;


        this.button.textContent =
          !variantId
            ? this.button.dataset.missingLabel
            : available
              ? this.button.dataset.readyLabel
              : this.button.dataset.soldOutLabel ||
                this.button.dataset.missingLabel;


        if (
          variant &&
          this.price &&
          Object.hasOwn(
            variant,
            'price'
          )
        ) {

          this.price.textContent =
            variant.price;

        }


        if (
          variant &&
          this.comparePrice &&
          Object.hasOwn(
            variant,
            'compareAtPrice'
          )
        ) {

          this.comparePrice.textContent =
            variant.compareAtPrice;


          this.comparePrice.hidden =
            !variant.compareAtPrice;

        }


        if (
          variant &&
          this.saving &&
          Object.hasOwn(
            variant,
            'saving'
          )
        ) {

          this.saving.textContent =
            variant.saving;


          this.saving.hidden =
            !variant.saving;

        }


        if (variant?.url) {

          this.productLinks.forEach(
            (link) =>
              link.setAttribute(
                'href',
                variant.url
              )
          );

        }


        this.updateVariantImage(
          variant
        );

      }


      updateVariantImage(variant) {

        if (
          !variant?.image ||
          !this.variantImage
        ) return;


        const currentImageUrl =
          new URL(
            this.variantImage.currentSrc ||
            this.variantImage.src,
            window.location.href
          ).href;


        const nextImageUrl =
          new URL(
            variant.image,
            window.location.href
          ).href;


        if (
          currentImageUrl ===
          nextImageUrl
        ) {

          this.variantImage.alt =
            variant.imageAlt ||
            this.variantImage.alt;

          return;

        }


        const pendingVariantId =
          String(
            variant.id
          );


        this.pendingImageId =
          pendingVariantId;


        this.variantImage.classList.add(
          'is-changing'
        );


        this.variantImage.onload =
          () => {

            if (
              this.pendingImageId !==
              pendingVariantId
            ) return;


            this.variantImage.alt =
              variant.imageAlt ||
              this.variantImage.alt;


            requestAnimationFrame(
              () =>
                this.variantImage.classList.remove(
                  'is-changing'
                )
            );

          };


        this.variantImage.onerror =
          () => {

            if (
              this.pendingImageId ===
              pendingVariantId
            ) {

              this.variantImage.classList.remove(
                'is-changing'
              );

            }

          };


        this.variantImage.removeAttribute(
          'srcset'
        );


        this.variantImage.removeAttribute(
          'sizes'
        );


        this.variantImage.src =
          nextImageUrl;

      }


      async addToCart() {

        const variantId =
          this.button?.dataset.variantId;


        if (!variantId) return;


        this.button.setAttribute(
          'aria-busy',
          'true'
        );


        this.button.disabled = true;


        if (this.error) {
          this.error.hidden = true;
        }


        document.documentElement.dispatchEvent(
          new CustomEvent(
            'theme:loading:start',
            {
              bubbles: true
            }
          )
        );


        const sections = [];


        document.documentElement.dispatchEvent(
          new CustomEvent(
            'cart:prepare-bundled-sections',
            {
              bubbles: true,

              detail: {
                sections
              }
            }
          )
        );


        try {

          const response =
            await fetch(
              `${Shopify.routes.root}cart/add.js`,
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  'X-Requested-With':
                    'XMLHttpRequest'
                },

                body: JSON.stringify({
                  items: [
                    {
                      id: variantId,
                      quantity: 1
                    }
                  ],

                  sections,

                  sections_url:
                    this.button.dataset.sectionUrl
                })
              }
            );


          const responseJson =
            await response.json();


          if (!response.ok) {

            throw new Error(
              responseJson.description ||
              responseJson.message ||
              'Unable to add to cart'
            );

          }


          const cart =
            await (
              await fetch(
                `${Shopify.routes.root}cart.js`
              )
            ).json();


          cart.sections =
            responseJson.sections || {};


          document.documentElement.dispatchEvent(
            new CustomEvent(
              'cart:change',
              {
                bubbles: true,

                detail: {
                  baseEvent:
                    'variant:add',

                  onSuccessDo:
                    'force_open_drawer',

                  cart
                }
              }
            )
          );


          this.button.textContent =
            this.button.dataset.addedLabel ||
            this.button.dataset.readyLabel;


          window.setTimeout(
            () => this.updateVariant(),
            1200
          );

        }

        catch (error) {

          if (this.error) {

            this.error.textContent =
              error.message;


            this.error.hidden =
              false;

          }


          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh'
            )
          );

        }

        finally {

          this.button.removeAttribute(
            'aria-busy'
          );


          if (
            this.button.textContent !==
            (
              this.button.dataset.addedLabel ||
              this.button.dataset.readyLabel
            )
          ) {

            this.updateVariant();

          }


          document.documentElement.dispatchEvent(
            new CustomEvent(
              'theme:loading:end',
              {
                bubbles: true
              }
            )
          );

        }

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-countdown"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('flash-sale-countdown')) {

  customElements.define(
    'flash-sale-countdown',

    class extends HTMLElement {

      connectedCallback() {

        this.update();

        this.timer =
          setInterval(
            () => this.update(),
            1000
          );

      }


      disconnectedCallback() {

        clearInterval(this.timer);

      }


      pad(value) {

        return String(
          Math.max(0, value)
        ).padStart(2, '0');

      }


      update() {

        const saleStart =
          new Date(this.dataset.start);

        const saleEnd =
          new Date(this.dataset.end);

        const now =
          new Date();


        let target =
          saleStart;

        let label =
          this.dataset.startLabel ||
          'Sale starts in';


        if (
          now >= saleStart &&
          now < saleEnd
        ) {

          target =
            saleEnd;

          label =
            this.dataset.endLabel ||
            'Sale ends in';

        }

        else if (
          now >= saleEnd
        ) {

          target =
            now;

          label =
            this.dataset.endedLabel ||
            'Sale ended';

        }


        document
          .querySelectorAll(
            '[data-flash-sale-countdown-label]'
          )
          .forEach(
            (element) => {

              element.textContent =
                label;

            }
          );


        let distance =
          Math.max(
            0,
            target - now
          );


        const days =
          Math.floor(
            distance / 86400000
          );


        distance -=
          days * 86400000;


        const hours =
          Math.floor(
            distance / 3600000
          );


        distance -=
          hours * 3600000;


        const minutes =
          Math.floor(
            distance / 60000
          );


        distance -=
          minutes * 60000;


        const seconds =
          Math.floor(
            distance / 1000
          );


        const values = {
          days,
          hours,
          minutes,
          seconds
        };


        Object
          .entries(values)
          .forEach(
            ([key, value]) => {

              document
                .querySelectorAll(
                  `[data-flash-sale-time="${key}"], [data-flash-sale-sticky="${key}"]`
                )
                .forEach(
                  (element) => {

                    element.textContent =
                      this.pad(value);

                  }
                );

            }
          );

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-sale-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('flash-sale-cart-form')) {

  customElements.define(
    'flash-sale-cart-form',

    class extends HTMLElement {

      connectedCallback() {

        this.button =
          this.querySelector(
            '[data-flash-sale-add]'
          );

        this.selector =
          this.querySelector(
            '[data-flash-sale-variant-select]'
          );

        this.error =
          this.querySelector(
            '[role="alert"]'
          );


        this.selector?.addEventListener(
          'change',
          () => this.updateVariant()
        );


        this.button?.addEventListener(
          'click',
          () => this.addToCart()
        );


        this.updateVariant();

      }


      updateVariant() {

        if (!this.button) return;


        const selectedValue =
          this.selector
            ? this.selector.value
            : this.button.dataset.variantId;


        this.button.dataset.variantId =
          selectedValue || '';


        const ready =
          Boolean(selectedValue);


        const available =
          this.button.dataset.available !==
          'false';


        this.button.disabled =
          !ready || !available;


        this.button.textContent =
          ready && available
            ? this.button.dataset.readyLabel
            : this.button.dataset.missingLabel;

      }


      async addToCart() {

        const variantId =
          this.button?.dataset.variantId;


        if (!variantId) return;


        this.button.setAttribute(
          'aria-busy',
          'true'
        );


        this.button.disabled = true;


        if (this.error) {
          this.error.hidden = true;
        }


        document.documentElement.dispatchEvent(
          new CustomEvent(
            'theme:loading:start',
            {
              bubbles: true
            }
          )
        );


        const sections = [];


        document.documentElement.dispatchEvent(
          new CustomEvent(
            'cart:prepare-bundled-sections',
            {
              bubbles: true,

              detail: {
                sections
              }
            }
          )
        );


        try {

          const response =
            await fetch(
              `${Shopify.routes.root}cart/add.js`,
              {
                method: 'POST',

                headers: {
                  'Content-Type':
                    'application/json',

                  'X-Requested-With':
                    'XMLHttpRequest'
                },

                body: JSON.stringify({
                  items: [
                    {
                      id: variantId,
                      quantity: 1
                    }
                  ],

                  sections,

                  sections_url:
                    this.button.dataset.sectionUrl
                })
              }
            );


          const responseJson =
            await response.json();


          if (!response.ok) {

            throw new Error(
              responseJson.description ||
              responseJson.message ||
              'Unable to add to cart'
            );

          }


          const cart =
            await (
              await fetch(
                `${Shopify.routes.root}cart.js`
              )
            ).json();


          cart.sections =
            responseJson.sections || {};


          document.documentElement.dispatchEvent(
            new CustomEvent(
              'cart:change',
              {
                bubbles: true,

                detail: {
                  baseEvent:
                    'variant:add',

                  onSuccessDo:
                    'force_open_drawer',

                  cart
                }
              }
            )
          );

        }

        catch (error) {

          if (this.error) {

            this.error.textContent =
              error.message;

            this.error.hidden =
              false;

          }


          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh'
            )
          );

        }

        finally {

          this.button.removeAttribute(
            'aria-busy'
          );


          this.updateVariant();


          document.documentElement.dispatchEvent(
            new CustomEvent(
              'theme:loading:end',
              {
                bubbles: true
              }
            )
          );

        }

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-sale-bundles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halloween-bundle')) {
    customElements.define('halloween-bundle', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const data = this.querySelector('[data-bundle-variants]');
        if (!data) return;
        this.variants = JSON.parse(data.textContent);
        const options = { signal: this.abortController.signal };
        this.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-bundle-option]');
          if (!choice || choice.disabled || this.querySelector('[aria-busy="true"]')) return;
          choice.parentElement.querySelectorAll('[data-bundle-option]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === choice));
          });
          this.updateVariant();
        }, options);
        this.addEventListener('submit', () => { this.querySelector('[data-bundle-error]').hidden = true; }, options);
        this.addEventListener('cart:error', (event) => {
          const error = this.querySelector('[data-bundle-error]');
          error.textContent = event.detail.error;
          error.hidden = false;
        }, options);
        this.updateVariant();
      }
      disconnectedCallback() { this.abortController?.abort(); }
      updateVariant() {
        const groups = [...this.querySelectorAll('[data-bundle-option-group]')];
        const selected = groups.map((group) => group.querySelector('[aria-pressed="true"]').dataset.value);
        const variant = this.variants.find((item) => item.options.every((value, index) => value === selected[index])) || (groups.length === 0 ? this.variants[0] : null);
        const input = this.querySelector('input[name="id"]');
        const submit = this.querySelector('[type="submit"]');
        input.value = variant?.id || '';
        input.disabled = !variant;
        submit.disabled = !variant?.available;
        this.querySelector('[data-bundle-add-label]').textContent = variant ? (variant.available ? this.dataset.addLabel : this.dataset.soldLabel) : this.dataset.unavailableLabel;
        this.querySelector('[data-bundle-selection]').textContent = `${this.dataset.selectedLabel} ${selected.join(' / ')}`;
        this.querySelector('[data-bundle-error]').hidden = true;
        this.querySelector('[data-bundle-link]').href = variant ? `${this.dataset.productUrl}?variant=${variant.id}` : this.dataset.productUrl;
        groups.forEach((group, index) => {
          group.querySelectorAll('[data-bundle-option]').forEach((button) => {
            button.disabled = !this.variants.some((item) => item.available && item.options.every((value, position) => value === (position === index ? button.dataset.value : selected[position])));
          });
        });
        this.querySelector('[data-bundle-discount]').hidden = !variant?.percent;
        this.querySelector('[data-bundle-compare]').hidden = !variant?.percent;
        this.querySelector('[data-bundle-saving]').hidden = !variant?.percent;
        if (!variant) return;
        this.querySelector('[data-bundle-price]').textContent = variant.price;
        this.querySelector('[data-bundle-compare]').textContent = variant.compare;
        this.querySelector('[data-bundle-percent]').textContent = `${variant.percent}%`;
        this.querySelector('[data-bundle-saving]').textContent = `${this.dataset.saveLabel} ${variant.saving} \u00b7 ${variant.percent}% ${this.dataset.offLabel}`;
        const image = this.querySelector('[data-bundle-image]');
        if (image && variant.image && image.getAttribute('src') !== variant.image) {
          image.removeAttribute('srcset');
          image.src = variant.image;
        }
        if (image) image.alt = `${this.querySelector('h3').textContent} / ${variant.options.join(' / ')}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-sale-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halloween-sale-countdown')) {
    customElements.define('halloween-sale-countdown', class extends HTMLElement {
      static get observedAttributes() { return ['data-start', 'data-end']; }

      connectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
        this.controller = new AbortController();
        this.update();
        this.timer = setInterval(() => this.update(), 1000);
        document.addEventListener('visibilitychange', () => this.update(), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
      }

      attributeChangedCallback() {
        if (this.isConnected) this.update();
      }

      update() {
        const timestamp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})$/;
        const start = timestamp.test(this.dataset.start) ? new Date(this.dataset.start).getTime() : NaN;
        const end = timestamp.test(this.dataset.end) ? new Date(this.dataset.end).getTime() : NaN;
        const now = Date.now();
        let distance = 0;
        let label;
        let phase;

        if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) {
          phase = 'invalid';
          label = this.dataset.invalidLabel;
        } else if (now < start) {
          phase = 'upcoming';
          label = this.dataset.startLabel;
          distance = start - now;
        } else if (now >= end) {
          phase = 'ended';
          label = this.dataset.endedLabel;
        } else {
          distance = end - now;
          phase = distance <= 48 * 3600000 ? 'final-call' : 'live';
          label = phase === 'final-call' ? this.dataset.finalLabel : this.dataset.endLabel;
        }

        const visible = (phase === 'live' || phase === 'final-call') && distance > 0 && distance <= 72 * 3600000;
        if (this.hidden === visible) {
          this.hidden = !visible;
          this.dispatchEvent(new Event('halloween:countdown-visibility', { bubbles: true }));
        }

        this.dataset.phase = phase;
        this.querySelectorAll('[data-halloween-countdown-label]').forEach(element => {
          if (element.textContent !== label) element.textContent = label;
        });
        const seconds = Math.floor(Math.max(0, distance) / 1000);
        const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        Object.entries(values).forEach(([key, value]) => {
          const text = String(value).padStart(2, '0');
          this.querySelectorAll(`[data-halloween-countdown-time="${key}"]`).forEach(element => {
            if (element.textContent !== text) element.textContent = text;
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-sale-diffusers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halloween-diffuser-card')) {
    customElements.define('halloween-diffuser-card', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.addEventListener('submit', () => { this.querySelector('[data-diffuser-error]').hidden = true; }, options);
        this.addEventListener('cart:error', (event) => {
          const error = this.querySelector('[data-diffuser-error]');
          error.textContent = event.detail.error;
          error.hidden = false;
        }, options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-sale-final"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halloween-final-scroll-crop')) {
    customElements.define('halloween-final-scroll-crop', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.halloween-final');
        if (!this.section) return;

        this.abortController?.abort();
        this.abortController = new AbortController();
        this.frame = 0;

        const options = {
          signal: this.abortController.signal
        };

        window.addEventListener(
          'scroll',
          () => this.scheduleUpdate(),
          { ...options, passive: true }
        );

        window.addEventListener(
          'resize',
          () => this.scheduleUpdate(),
          { ...options, passive: true }
        );

        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.abortController?.abort();

        if (this.frame) {
          cancelAnimationFrame(this.frame);
        }

        this.frame = 0;
        this.style.removeProperty('--halloween-pan-position');
      }

      scheduleUpdate() {
        if (this.frame) return;

        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }

      update() {
        if (window.innerWidth <= 700) {
          this.style.removeProperty('--halloween-pan-position');
          return;
        }

        const rect = this.section.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const range = viewportHeight + rect.height;

        /*
         * 0%: CTA enters from the viewport bottom.
         * 100%: CTA leaves through the viewport top.
         */
        const progress = Math.max(
          0,
          Math.min(
            1,
            (viewportHeight - rect.top) / Math.max(1, range)
          )
        );

        this.style.setProperty(
          '--halloween-pan-position',
          `${(progress * 100).toFixed(2)}%`
        );
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-sale-oils"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('halloween-oil-carousel')) {
  customElements.define('halloween-oil-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      const options = { signal: this.abortController.signal };

      this.grid = this.querySelector('.halloween-oils__grid');
      this.previous = this.querySelector('[data-oils-prev]');
      this.next = this.querySelector('[data-oils-next]');
      this.progress = this.querySelector('[data-oils-progress]');

      if (!this.grid || !this.previous || !this.next || !this.progress) return;

      const seasonalNames = [
        'pumpkin hearth',
        'winter vale',
        'christmas cranberry',
        'apple cinnamon',
        'fireside ember'
      ];

      const originalCards = [...this.querySelectorAll('[data-oil-moving]')]
        .sort((a, b) => Number(a.dataset.oilIndex) - Number(b.dataset.oilIndex));

      const isNew = card =>
        card.dataset.oilNew === 'true' ||
        seasonalNames.some(name =>
          (card.dataset.oilTitle || '').includes(name)
        );

      this.cards = [
        ...originalCards.filter(card => !isNew(card)),
        ...originalCards.filter(isNew)
      ];

      this.mobileQuery = window.matchMedia('(max-width: 700px)');
      this.pageSize = this.mobileQuery.matches ? 1 : 3;
      this.pageCount = Math.max(1, Math.ceil(this.cards.length / this.pageSize));
      this.page = 0;

      this.previous.addEventListener(
        'click',
        () => this.changePage(-1),
        options
      );

      this.next.addEventListener(
        'click',
        () => this.changePage(1),
        options
      );

      this.mobileQuery.addEventListener(
        'change',
        () => this.updatePageSize(),
        options
      );

      this.addEventListener('submit', event => {
        const error = event.target.closest('[data-oil-card]')?.querySelector('[data-oil-error]');
        if (error) error.hidden = true;
      }, options);

      this.addEventListener('cart:error', event => {
        const error = event.target.closest('[data-oil-card]')?.querySelector('[data-oil-error]');
        if (!error) return;

        error.textContent = event.detail?.error || 'Unable to add this item.';
        error.hidden = false;
      }, options);

      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('[data-oil-moving]'));
        if (index < 0) return;

        this.page = Math.floor(index / this.pageSize);
        this.renderPage();
      }, options);

      this.renderPage();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    updatePageSize() {
      const firstIndex = this.page * this.pageSize;

      this.pageSize = this.mobileQuery.matches ? 1 : 3;
      this.pageCount = Math.max(
        1,
        Math.ceil(this.cards.length / this.pageSize)
      );

      this.page = Math.min(
        this.pageCount - 1,
        Math.floor(firstIndex / this.pageSize)
      );

      this.renderPage();
    }

    changePage(direction) {
      if (this.querySelector('[aria-busy="true"]')) return;

      this.page = (
        this.page +
        direction +
        this.pageCount
      ) % this.pageCount;

      this.renderPage();
    }

    renderPage() {
      const start = this.page * this.pageSize;
      const visible = this.cards.slice(start, start + this.pageSize);

      this.cards.forEach(card => {
        const slot = visible.indexOf(card);

        card.hidden = slot === -1;
        card.style.order = slot + 1;
        card.classList.toggle('is-current', slot !== -1);
      });

      visible.forEach(card => this.grid.append(card));

      this.progress.textContent =
        `${String(this.page + 1).padStart(2, '0')} / ${String(this.pageCount).padStart(2, '0')}`;

      this.previous.hidden = this.next.hidden = this.pageCount === 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-sale-preorders"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('halloween-preorder-carousel')) {
  customElements.define('halloween-preorder-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.abortController = new AbortController();
      this.grid = this.querySelector('[data-preorder-grid]');
      this.previous = this.querySelector('[data-preorder-prev]');
      this.next = this.querySelector('[data-preorder-next]');
      this.scrollbar = this.querySelector('[data-preorder-scrollbar]');
      this.scrollbarTrack = this.querySelector('[data-preorder-track]');
      this.scrollbarProgress = this.querySelector('[data-preorder-progress]');
      this.scrollbarThumb = this.querySelector('[data-preorder-thumb]');
      if (!this.grid || !this.previous || !this.next || !this.scrollbar || !this.scrollbarTrack || !this.scrollbarProgress || !this.scrollbarThumb) return;
      const options = { signal: this.abortController.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.grid.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });

      // The track and pumpkin scrub the real horizontal product grid.
      this.scrollbarTrack.addEventListener('pointerdown', (event) => {
        if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
        event.preventDefault();
        this.scrollbarThumb.focus({ preventScroll: true });
        const onThumb = this.scrollbarThumb.contains(event.target);
        const thumbRect = this.scrollbarThumb.getBoundingClientRect();
        this.scrub = {
          id: event.pointerId,
          lastX: event.clientX,
          grabOffset: onThumb ? event.clientX - (thumbRect.left + thumbRect.width / 2) : 0
        };
        this.grid.classList.add('is-scrubbing');
        this.scrollbar.classList.add('is-scrubbing');
        this.scrollbarTrack.setPointerCapture(event.pointerId);
        if (!onThumb) this.scrubTo(event.clientX);
      }, options);
      this.scrollbarTrack.addEventListener('pointermove', (event) => {
        if (!this.scrub || event.pointerId !== this.scrub.id) return;
        if (event.clientX > this.scrub.lastX + 1) {
          this.scrollbarThumb.classList.remove('is-tilt-left');
          this.scrollbarThumb.classList.add('is-tilt-right');
        } else if (event.clientX < this.scrub.lastX - 1) {
          this.scrollbarThumb.classList.remove('is-tilt-right');
          this.scrollbarThumb.classList.add('is-tilt-left');
        }
        this.scrub.lastX = event.clientX;
        this.scrubTo(event.clientX);
      }, options);
      this.scrollbarTrack.addEventListener('pointerup', (event) => {
        if (!this.scrub || event.pointerId !== this.scrub.id) return;
        this.scrubTo(event.clientX);
        this.endScrub(true);
      }, options);
      this.scrollbarTrack.addEventListener('pointercancel', () => this.endScrub(true), options);
      this.scrollbarTrack.addEventListener('lostpointercapture', () => this.endScrub(true), options);
      this.scrollbarThumb.addEventListener('keydown', (event) => {
        const maxScroll = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          this.grid.scrollBy({ left: direction * this.cardStep(), behavior: this.behavior() });
        } else if (event.key === 'PageUp' || event.key === 'PageDown') {
          event.preventDefault();
          this.move(event.key === 'PageDown' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.grid.scrollTo({ left: event.key === 'Home' ? 0 : maxScroll, behavior: this.behavior() });
        }
      }, options);
      this.grid.addEventListener('keydown', (event) => {
        if (event.target !== this.grid) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.grid.scrollTo({ left: event.key === 'Home' ? 0 : this.grid.scrollWidth, behavior: this.behavior() });
        }
      }, options);
      this.grid.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.preventClick = false;
        this.drag = { id: event.pointerId, start: event.clientX, left: this.grid.scrollLeft, active: false };
      }, options);
      this.grid.addEventListener('pointermove', (event) => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        if (!(event.buttons & 1)) { this.endDrag(); return; }
        const distance = event.clientX - this.drag.start;
        if (!this.drag.active && Math.abs(distance) > 6) {
          this.drag.active = true;
          this.preventClick = true;
          this.grid.classList.add('is-dragging');
          this.grid.setPointerCapture(event.pointerId);
        }
        if (!this.drag.active) return;
        event.preventDefault();
        this.grid.scrollLeft = this.drag.left - distance;
      }, options);
      this.grid.addEventListener('pointerup', () => this.endDrag(), options);
      this.grid.addEventListener('pointercancel', () => this.endDrag(), options);
      this.grid.addEventListener('lostpointercapture', () => this.endDrag(), options);
      this.grid.addEventListener('dragstart', (event) => event.preventDefault(), options);
      this.grid.addEventListener('click', (event) => {
        if (!this.preventClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.preventClick = false;
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.halloween-preorder-card');
        if (!card) return;
        const left = card.getBoundingClientRect().left - this.grid.getBoundingClientRect().left + this.grid.scrollLeft;
        this.grid.scrollTo({ left, behavior: 'auto' });
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.updateControls());
      this.resizeObserver.observe(this.grid);
      this.updateControls();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.endScrub(false);
      this.endDrag();
    }
    scrubTo(clientX) {
      const rect = this.scrollbarTrack.getBoundingClientRect();
      const fraction = Math.max(0, Math.min(1, (clientX - (this.scrub?.grabOffset || 0) - rect.left) / Math.max(rect.width, 1)));
      const maxScroll = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
      this.grid.scrollLeft = fraction * maxScroll;
      this.updateControls();
    }
    endScrub(snap) {
      if (!this.scrub) return;
      const id = this.scrub.id;
      this.scrub = null;
      this.grid?.classList.remove('is-scrubbing');
      this.scrollbar?.classList.remove('is-scrubbing');
      this.scrollbarThumb?.classList.remove('is-tilt-left', 'is-tilt-right');
      if (this.scrollbarTrack?.hasPointerCapture(id)) this.scrollbarTrack.releasePointerCapture(id);
      if (snap && this.grid) {
        const step = this.cardStep();
        if (step > 0) {
          const max = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
          const left = Math.max(0, Math.min(max, Math.round(this.grid.scrollLeft / step) * step));
          this.grid.scrollTo({ left, behavior: this.behavior() });
        }
      }
    }
    cardStep() {
      const card = this.grid?.querySelector('.halloween-preorder-card');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    endDrag() {
      const drag = this.drag;
      this.drag = null;
      this.grid?.classList.remove('is-dragging');
      if (drag && this.grid.hasPointerCapture(drag.id)) this.grid.releasePointerCapture(drag.id);
    }
    behavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    move(direction) {
      const step = this.cardStep();
      if (step <= 0) return;
      const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
      const visible = Math.max(1, Math.round((this.grid.clientWidth + gap) / step));
      this.grid.scrollBy({ left: direction * step * visible, behavior: this.behavior() });
    }
    updateControls() {
      const end = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
      this.previous.hidden = this.next.hidden = end < 2;
      this.previous.disabled = this.grid.scrollLeft < 2;
      this.next.disabled = this.grid.scrollLeft >= end - 2;

      // Two-way synchronization: arrows, touch swipes, mouse drag, editor selection and resize.
      this.scrollbar.hidden = end < 2;
      const current = Math.max(0, Math.min(end, this.grid.scrollLeft));
      const percent = end > 0 ? (current / end) * 100 : 0;
      const value = `${percent}%`;
      this.scrollbarProgress.style.width = value;
      this.scrollbarThumb.style.left = value;
      this.scrollbarThumb.setAttribute('aria-valuenow', String(Math.round(percent)));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-sale-pumpkin"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('halloween-pumpkin')) {
    customElements.define('halloween-pumpkin', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const data = this.querySelector('[data-pumpkin-variants]');
        if (!data) return;
        this.variants = JSON.parse(data.textContent);
        const options = { signal: this.abortController.signal };
        this.addEventListener('click', (event) => {
          const copy = event.target.closest('[data-pumpkin-copy]');
          if (copy) { this.copyCoupon(copy); return; }
          const button = event.target.closest('[data-pumpkin-variant]');
          if (!button || button.disabled || this.querySelector('[aria-busy="true"]')) return;
          this.updateVariant(button.dataset.pumpkinVariant);
        }, options);
        this.addEventListener('submit', () => { this.querySelector('[data-pumpkin-error]').hidden = true; }, options);
        this.addEventListener('cart:error', (event) => {
          const error = this.querySelector('[data-pumpkin-error]');
          error.textContent = event.detail.error;
          error.hidden = false;
        }, options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
      async copyCoupon(button) {
        const feedback = button.querySelector('[data-pumpkin-copy-feedback]');
        try {
          await navigator.clipboard.writeText(button.dataset.pumpkinCopy);
          if (this.isConnected) feedback.textContent = 'Copied';
        } catch {
          if (this.isConnected) feedback.textContent = 'Use PUMPKIN45 at checkout';
        }
      }
      updateVariant(id) {
        const variant = this.variants.find((item) => item.id === id);
        if (!variant) return;
        this.querySelectorAll('[data-pumpkin-variant]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.pumpkinVariant === id)));
        this.querySelector('input[name="id"]').value = variant.id;
        const submit = this.querySelector('[type="submit"]');
        submit.disabled = !variant.available;
        const label = variant.available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.querySelector('[data-pumpkin-add-label]').textContent = label;
        submit.setAttribute('aria-label', `${label} - ${variant.label}`);
        this.querySelector('[data-pumpkin-price]').textContent = variant.price;
        const compare = this.querySelector('[data-pumpkin-compare]');
        compare.textContent = variant.compareAt || '';
        compare.hidden = !variant.compareAt;
        this.querySelector('[data-pumpkin-error]').hidden = true;
        const link = this.querySelector('[data-pumpkin-link]');
        if (link) {
          link.href = `${this.dataset.productUrl}?variant=${variant.id}`;
          link.setAttribute('aria-label', `${this.dataset.imageAlt} - ${variant.label}`);
        }
        const image = this.querySelector('[data-pumpkin-image]');
        if (image && variant.image) {
          image.removeAttribute('srcset');
          image.src = variant.image;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
